import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
// import {BathTubType, LayoutType} from "../constants";
import {bathTubThumbnail} from "../../../bvComponent/core/assets";

import BathTubBody from "../subparts/bathTub/bathTubBody";
import BathTubFixture from "../subparts/bathTub/bathTubFixture";
import EnclosureTop from "../subparts/bathTub/enclosureTop";
import EnclosureBottom from "../subparts/bathTub/enclosureBottom";
import SkirtingBoard from "../subparts/bathTub/skirtingBoard";

export class Bathtub extends Part {
  static id = 'Bathtub';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Bathtub';
    this.translateId = "visualizer.bathroom.bathtub";
    this.partThumbnail = bathTubThumbnail;
    this.bathTubBody = null;
    this.bathTubFixture = null;
    this.enclosureTop = null;
    this.enclosureBottom = null;
    this.skirtingBoard = null;
    this.relatedItems = [];
    this.relatedGroupNames = ["Bathtub", "Bathtub Fixture", "Enclosure Top", "Enclosure Bottom", "Skirting Board"];

  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bathtub":
        relatedItemName = "bathTubBody";
        RelatedItemClass = BathTubBody;
        break;
      case "Bathtub Fixture":
        relatedItemName = "bathTubFixture";
        RelatedItemClass = BathTubFixture;
        break;
      case "Enclosure Top":
      case "EnclosureTop":
        relatedItemName = "enclosureTop";
        RelatedItemClass = EnclosureTop;
        break;
      case "Enclosure Bottom":
      case "EnclosureBottom":
        relatedItemName = "enclosureBottom";
        RelatedItemClass = EnclosureBottom;
        break;
      case "Skirting Board":
        relatedItemName = "skirtingBoard";
        RelatedItemClass = SkirtingBoard;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  changeLayout() {
  // changeLayout(layoutType) {
    // if (layoutType === LayoutType.Layout1 && this.bathTubBody) {
    //   // this.activeSubType_ = BathTubType.Custom60in;
    //   // this.bathTubType_ = BathTubType.Custom60in;
    //   if (!this.layout.parts.Shower.showerBody.disabled) { // disable bathtub if shower is active
    //     if (this.bathTubBody) {
    //       this.bathTubBody.disabled = true;
    //     }
    //   }
    // } else {
    //   if (this.bathTubBody) {
    //     this.bathTubBody.disabled = false;
    //   }
    // }
  }
}
